import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as customFieldsActionTypes } from '../../actions/customFields';

export default makeCrudMetaReducer(customFieldsActionTypes);
